<template>
  <div class="astrologyhome">
    <div
      v-if="draw_nav_layout == true"
      class="main-panel main-panel-customer-astrology w-100"
      :style="{ 'background-image': 'url(' + background_img + ')' }"
    >
      <AstrologyNavbar />
      <div class="content">
        <router-view :key="$route.fullPath" />
      </div>
      <AstrologyFooter v-if="draw_footer == true" class="mt-3" />
      <!-- <AstrologyFooter /> -->
    </div>
    <router-view :key="$route.fullPath" v-else />
  </div>
</template>


<script>
import $ from "jquery";
import AstrologyNavbar from "@/components/partials/navbar_astrology";
import AstrologyFooter from "@/components/partials/footer_astrology";

export default {
  name: "AstrologyCustomerIndex",
  components: { AstrologyNavbar, AstrologyFooter },
  data() {
    return {
      loginuser: null,
      background_img: "none",
      draw_nav_layout: true,
      draw_footer: true,
    };
  },

  mounted() {
    // console.log("rrrrrr " + this.$route.name);
    // console.log("session ", localStorage.getItem("user"));
    this.setPageBackground();
    this.checkRoute();
  },
  updated() {
    // console.log("in index updated ",this.$route.name);
    this.setPageBackground();
    this.checkRoute();
    this.checkPageToDrawFooter();

    // alert("home updated");
    // console.log($(".nav-open"));
    if ($(".navbar-collapse.collapse").hasClass("show")) {
      $(".navbar-collapse.collapse").removeClass("show");
    }
  },
  methods: {
    setPageBackground() {
      if (
        this.$route.name == "AstrologyCustomerHome" ||
        this.$route.name == "AstrologyCustomerCreateBirthChartIndex"
      ) {
        this.background_img = require("@/assets/images/astrology/customer-background.png");
      }
      // else if (this.$route.name == "AstrologyCustomerEventsCalendar") {
      //   this.background_img = require("@/assets/images/astrology/mountain_background.png");
      //   // $("#app").css("background-image",'url('+require("@/assets/images/astrology/mountain_background.png")+')')
      // } else if (
      //   this.$route.name == "AstrologyCustomerProfileIndex" ||
      //   this.$route.name == "AstrologyCustomerEditProfile" ||
      //   this.$route.name == "AstrologyCustomerProfileSubscription"
      // ) {
      //   this.background_img = require("@/assets/images/astrology/profile-background.png");
      // }
      else {
        this.background_img = "none";
      }
    },
    checkRoute() {
      // if (
      //   this.$route.name == "AstrologyCustomerEventsBookSummary" ||
      //   this.$route.name == "AstrologyCustomerEventsBookAsGuest" ||
      //   this.$route.name == "AstrologyCustomerEventsBookPayment"
      // ) {
      //   this.draw_nav_layout = false;
      // } else {
      //   this.draw_nav_layout = true;
      // }
    },
    checkPageToDrawFooter() {
      if (
        this.$route.name == "AstrologyCustomerHome" 
      ) {
        this.draw_footer = true;
      } else {
        this.draw_footer = false;
      }
    },
  },
};
</script>
<style scoped::v-deep >
@import "../css/astrology-buttons-styles.css";
@import "../css/astrology-customer-styles.css";
</style>


// WEBPACK FOOTER //
// src/components/astrology_ventures/customer/Index.vue